// Content sourced verbatim from the client's supplied Melbourne guide copy.
import { galleryFrom, leadFrom, countFrom } from "./fromModels";
import models from "../models.json";

const slug = "the-pink-palace";

const pinkPalace = {
  slug,
  name: "The Pink Palace",
  short: "Pink Palace",
  badge: "South Melbourne",
  suburb: "South Melbourne",
  established: "Originally Palmerston Crescent",
  tagline:
    "A name traditionally associated with the more luxurious side of Melbourne's brothel scene.",
  lead: (models[slug] || []).filter((m) => m.img)[3]?.img || leadFrom(slug),
  theme: {
    bg: "bg-[#fdf1f7]",
    chip: "bg-[#fbd9e9] text-[#8a1d52]",
    rule: "border-[#f0a9c9]",
    accent: "text-[#a32069]",
  },
  gallery: galleryFrom(slug, 12).slice(6, 12),
  highlights: [
    { icon: "Users", label: `${countFrom(slug)} Ladies` },
    { icon: "MapPin", label: "South Melbourne" },
    { icon: "Clock", label: "Confirm current hours" },
  ],
  contact: {
    address: "55 Park Street, South Melbourne",
  },
  nav: [
    { id: "introduction", label: "Introduction" },
    { id: "models", label: "Models" },
  ],
  sections: [
    {
      id: "introduction",
      eyebrow: "The Pink Palace, South Melbourne",
      title: "The Pink Palace, South Melbourne",
      blocks: [
        {
          t: "lead",
          text: "Current listings have associated the name with: 55 Park Street, South Melbourne",
        },
        {
          t: "p",
          text: "The Pink Palace is one of those Melbourne names that people may recognise even if they've never been inside.",
        },
        {
          t: "p",
          text: "Its history goes back to an earlier South Melbourne location on Palmerston Crescent, where the business became known for its distinctive identity and more elaborate surroundings.",
        },
        {
          t: "p",
          text: "That original premises attracted attention over the years and developed a reputation of its own.",
        },
        {
          t: "p",
          text: "But there's something people should know before relying on old information about The Pink Palace.",
        },
        {
          t: "p",
          text: "The Palmerston Crescent location belongs to the business's earlier history. More recent listings have associated the Pink Palace name with Park Street.",
        },
        {
          t: "p",
          text: "That creates some confusion because The Harem Palace is also connected with 55 Park Street.",
        },
        {
          t: "p",
          text: "The overlap doesn't necessarily explain how the businesses are currently organised, so it's sensible to confirm the correct address and booking details directly rather than assume the older and newer listings refer to separate operating premises.",
        },
        {
          t: "p",
          text: "This is especially important when reading customer reviews.",
        },
        {
          t: "p",
          text: "Someone describing The Pink Palace from ten or fifteen years ago may be talking about a location that no longer operates in the same way.",
        },
        {
          t: "p",
          text: "The name itself has traditionally been associated with the more luxurious side of Melbourne's brothel scene.",
        },
        {
          t: "p",
          text: "It became familiar for the idea of an adult establishment offering something more elaborate than a basic private room.",
        },
        {
          t: "p",
          text: "Whether that particular style is what someone wants is a matter of taste.",
        },
        {
          t: "p",
          text: "There are people who enjoy the atmosphere of larger venues. Others prefer somewhere smaller, with fewer distractions.",
        },
        {
          t: "p",
          text: "Older feedback about The Pink Palace includes both favourable memories and criticism, which isn't particularly surprising given how long the name has been around.",
        },
        {
          t: "p",
          text: "Just be careful about treating historical reputation as a current review.",
        },
        {
          t: "p",
          text: "For anyone researching The Pink Palace, the best approach is to establish which premises are operating under that name today and what arrangements are currently available.",
        },
      ],
    },
  ],
};

export default pinkPalace;
